<template>
  <v-container class="pa-0 mb-5">
    <v-card class="ma-4">
      <video class="responsive-video d-block mh-auto" controls poster="../../assets/images/intro-poster.jpg">
        <source :src="introVideoUrl"/>
      </video>
      <v-card-text v-html="$t('TXT.INTRO_PAGE_INTRO_HTML')"></v-card-text>
      <v-card-actions class="border-top">
        <v-spacer></v-spacer>
        <v-btn dark flat color="primary" class="ml-auto" to="/aboutus">{{ $t('LBL.LEARN_MORE') }}</v-btn>
      </v-card-actions>
    </v-card>
    <bottom-toolbar></bottom-toolbar>
  </v-container>
</template>

<script>
import BottomToolbar from '@/components/elements/BottomToolbar'

export default {
  name: 'IntroPage',
  components: {
    'bottom-toolbar': BottomToolbar
  },
  created () {
    this.$store.commit('UPDATE_APP_STEP', 3)

    this.introVideoUrl = this.$i18n.t(`INTRO_VIDEO_URL`).trim()
  },
  data () {
    return {
      introVideoUrl: {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/styles/_colors.scss';

.card__text {
  & /deep/ blockquote {
    color: $grey-darken1 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/IntroPage.vue